export function formatRange (range) {
  range.from = range.from ? +range.from : null
  range.to = range.to ? +range.to : null
}
